import React, { useState, useRef, useEffect } from 'react';
import '../styles/components/FilterButton.css';
import FilterPanel from './FilterPanel';
import { ResourceFilterConfig } from '../types/filterTypes';

interface FilterButtonProps {
  filters: Record<string, any>;
  filterConfig: ResourceFilterConfig;
  onFilterChange: (filters: Record<string, any>) => void;
  className?: string;
}

const FilterButton: React.FC<FilterButtonProps> = ({ 
  filters, 
  filterConfig,
  onFilterChange,
  className = '' 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);

  // Close the panel when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isOpen && 
          buttonRef.current && 
          panelRef.current && 
          !buttonRef.current.contains(event.target as Node) &&
          !panelRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const togglePanel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`filter-button-container ${className}`}>
      <button
        ref={buttonRef}
        className={`filter-button ${isOpen ? 'active' : ''}`}
        onClick={togglePanel}
        title="Filter"
      >
        <span className="material-icons">filter_list</span>
      </button>
      
      {isOpen && (
        <div ref={panelRef} className="filter-panel-container">
          <FilterPanel 
            filters={filters}
            filterConfig={filterConfig}
            onFilterChange={onFilterChange}
            onClose={() => setIsOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default FilterButton; 